'use client'

import { useEffect, useState } from "react"
import Dropdown from "@/components/form/Dropdown"
import moment from "moment"
import { formatPrice } from "@/services/number"
import { getTotalPrice } from "@/services/booking"
import { createObjectActionPagePathname, createObjectPagePathname } from "@/services/pathname"
import Contact from "./contact"
import { accomodationTypes, getEndDate } from "@/services/bafad"
import { useRouter } from "next/navigation"

type BookingSidebarProps = {
    bafad: Bafad,
    proposedBy: Aroeven & AroevenStaffs,
    accomodationOption: BafadAccomodationOption
}

export default function BookingSidebar({
    bafad,
    proposedBy,
    accomodationOption
}: BookingSidebarProps) {

    moment.locale('fr')

    const { replace } = useRouter()

    // TODO : adapter selon searchParams
    const [booking, setBooking] = useState({
        accomodationOption,
        options: []
    })

    useEffect(() => {
        setBooking({
            ...booking,
            accomodationOption,

        })
    }, [accomodationOption])

    const endDate = getEndDate(bafad)
    const sameDate = moment(bafad.startDate1).format('YYYY-MM-DD') === moment(endDate).format('YYYY-MM-DD')

    const isPastBafad = moment(bafad.startDate1).isSameOrBefore(moment(), 'day')

    return (
        <>
            <div className="d-flex flex-column flex-md-row flex-lg-column justify-end" data-offset={450}>
                <div className="encart-1 ml-lg-0 px-30 py-30 bg-bloc w-360">
                    <div className="row y-gap-15 items-center justify-between">
                        <div className="col-auto">
                            <div className="text-14 text-light-1">
                                <h4>A partir de {Math.floor(Math.min(...bafad.accomodationOptions.map(option => option.price)) / 100)}€ par participant</h4>
                                <span className="info">hors assurance</span>
                            </div>
                        </div>
                    </div>
                    <div className="row y-gap-20 pt-5">
                        <div className="col-12">
                            <div className="select bafa libelle mb-15">
                                {sameDate === true ?
                                    <span className="title">Le {moment(bafad.startDate1).format('ddd DD/MM/YY')}</span>
                                    :
                                    <>
                                        <span className="title">Du {moment(bafad.startDate1).format('ddd DD/MM/YY')} au {moment(bafad.endDate1).format('ddd DD/MM/YY')}</span>
                                        {bafad.startDate2 && bafad.endDate2 && <span className="title">et du {moment(bafad.startDate2).format('ddd DD/MM/YY')} au {moment(bafad.endDate2).format('ddd DD/MM/YY')}</span>}
                                    </>
                                }
                            </div>
                            {isPastBafad === false &&
                                <>
                                    {bafad.availablePlaces > 0 ?
                                        <>
                                            <Dropdown
                                                className="mb-15"
                                                withLabel={true}
                                                options={bafad.accomodationOptions.reduce((options: any, accomodationOption: BafadAccomodationOption) => {
                                                    return {
                                                        ...options,
                                                        [accomodationOption['@id']]: {
                                                            label: accomodationTypes[accomodationOption.accomodationType]?.name ?? 'Inconnu',
                                                            sub: formatPrice(accomodationOption.price) + '€'
                                                        }
                                                    }
                                                }, {})}
                                                subTitle="Mode d'accueil"
                                                value={booking.accomodationOption?.['@id'] ?? ''}
                                                nullable={false}
                                                multiple={false}
                                                search={false}
                                                onChange={(value) => {
                                                    console.log('accomodationOption ' + value)
                                                    setBooking({
                                                        ...booking,
                                                        accomodationOption: bafad.accomodationOptions.filter(o => o['@id'] === value)[0] ?? bafad.accomodationOptions[0]
                                                    })
                                                }}
                                            />
                                            {bafad.options.length > 0 &&
                                                <Dropdown
                                                    className="mb-15"
                                                    withLabel={true}
                                                    options={bafad.options.reduce((options: any, option: any) => {
                                                        return {
                                                            ...options,
                                                            [option.id]: {
                                                                label: option.name,
                                                                sub: formatPrice(option.price) + '€'
                                                            }
                                                        }
                                                    }, {})}
                                                    subTitle="Options"
                                                    value={booking.options.map(option => option.id)}
                                                    placeholder="Aucune option"
                                                    nullable={false}
                                                    multiple={{
                                                        maxDisplayedItems: 2,
                                                        overMaxDisplayedItemsLabel: " options"
                                                    }}
                                                    search={false}
                                                    onChange={(value) => {
                                                        setBooking({
                                                            ...booking,
                                                            options: value.map(o => bafad.options.filter(option => option.id === o)[0] ?? null).filter(option => option)
                                                        })
                                                    }}
                                                />
                                            }
                                            <div className="col-auto">
                                                <div className="d-flex justify-content-end">
                                                    <div className="text-14 text-right mr-10">
                                                        <div className="total">Total : {formatPrice(getTotalPrice('Bafad', booking))}€</div>
                                                        <div className="info text-13 text-light-1">
                                                            hors assurance
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 mt-15">
                                                <a href={createObjectActionPagePathname('Bafad', bafad, 'booking')} className="button-primary d-block w-100">
                                                    Réserver
                                                </a>
                                                {bafad.availablePlaces < 5 &&
                                                    <p className="last-chance text-13 font-primary">
                                                        Dernière{bafad.availablePlaces > 1 && <>s</>} place{bafad.availablePlaces > 1 && <>s</>} disponible{bafad.availablePlaces > 1 && <>s</>}
                                                    </p>
                                                }
                                            </div>
                                        </>
                                        :
                                        <>
                                            {/*<div className="total">COMPLET</div>*/}
                                            <div className="badge rounded-pill bg-terracotta fs-5 w-100 font-primary">COMPLET</div>
                                        </>
                                    }
                                </>
                            }
                        </div>
                    </div>
                    {/* TODO : à activer plus tard */}
                    {/*<span className="info d-block mt-10">
                        <i className="fi fi-rr-info" />
                        Vous pourrez ajouter des participants à l'étape suivante.
                    </span>*/}
                </div>
                <Contact
                    bafad={bafad}
                    proposedBy={proposedBy}
                />
            </div>
        </>
    )
}